import { Steps } from "antd";
import React, { useEffect } from "react";
import { useState } from "react";
import { getArrayDocDataByRef } from "../models/DataFunctions";
import Icon1 from "../icons/Icon";
import updateDocDataFieldApi from "../api/database/updateDocDataFieldApi";
import { isFolderAdmin } from "../pages/folder_pages/FolderHelpers";

const TimelineFolderAudit = ({
  folderData,
  orgData,
  handleFetchData,
  prefix,
  handleClickVariant,
}) => {
  const handleSetFolderStep = async (step) => {
    await updateDocDataFieldApi(
      folderData.ref,
      "timeline.current_step",
      step,
      prefix
    );
    handleClickVariant("L'étape a été mise à jour avec succès", "success");
    setCurrent(step);
    await handleFetchData();
  };
  const [hoverStep, setHoverStep] = useState(-1);

  const [current, setCurrent] = useState(0);
  let compare_current = hoverStep === -1 ? current : hoverStep;
  const handleTimeline = async () => {
    let current = folderData.timeline?.current_step || 0;
    setCurrent(current);
  };

  useEffect(() => {
    const steps = audit_steps_titles.map((title, index) => {
      return { title: title, description: "" };
    });

    handleTimeline();

    setSteps(steps);
  }, [folderData]);

  const [steps, setSteps] = useState([]);

  return (
    <div className="flex flex-col  w-full  ">
      <BetterSteps
        items={steps}
        current={compare_current}
        setHoverStep={setHoverStep}
        onClick={handleSetFolderStep}
        orgData={orgData}
        folderData={folderData}
      />
    </div>
  );
};

export default TimelineFolderAudit;

export const BetterSteps = ({
  items,
  current,
  setHoverStep,
  onClick,
  orgData,
  folderData,
}) => {
  return (
    <div className="flex items-center justify-center flex-col gap-4  w-full">
      <div className="flex flex-row  w-full ml-10 min-h-fit">
        {items.map((item, index) => (
          <div
            onMouseEnter={() => {
              isFolderAdmin(orgData, folderData) && setHoverStep(index);
            }}
            onMouseLeave={() => {
              isFolderAdmin(orgData, folderData) && setHoverStep(-1);
            }}
            key={index}
            onClick={() => isFolderAdmin(orgData, folderData) && onClick(index)}
            className={`flex w-full ${isFolderAdmin(orgData, folderData) ? "cursor-pointer" : ""}  h-4 flex-row items-center justify-start min-h-fit `}
          >
            <div
              className={` min-w-8 h-8  rounded-full items-center justify-center flex  ${index < current ? "bg-green-50" : index === current ? "bg-blue-50" : "bg-gray-50"}`}
            >
              <Icon1
                icon_name={
                  index < current
                    ? "done2"
                    : index === current
                      ? "warning"
                      : "horloge"
                }
                size={20}
                fill={
                  index < current
                    ? "#0cf480"
                    : index === current
                      ? "#0071ff"
                      : "lightgrey"
                }
              />
            </div>
            {index !== items.length - 1 && (
              <div
                className={` w-full  h-0.5 rounded-full  px-1 ${index < current - 1 ? "bg-green-100" : index === current - 1 ? "bg-blue-200" : "bg-gray-100"}`}
              ></div>
            )}
          </div>
        ))}
      </div>
      <div className="flex flex-row justify-between w-full  pr-4 pl-4 mr-8   gap-4 min-h-fit items-start">
        {items.map((item, index) => (
          <div
            key={index}
            className="flex flex-1  items-center justify-start min-h-fit"
          >
            <div
              className={`text-h4 min-h-fit text-center  font-medium ${index < current ? "text-shadow_50" : index === current ? "text-black" : "text-shadow_25"}`}
            >
              {item.title}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export const audit_steps_titles = [
  "En prospection",
  "RDV Audit-MAR 1",
  "Audit restitué",
  "En contrôle conformité",
  "Déposé/ en instruction",
  "Dossier octroyé",
  "Demande paiement",
  "Visite MAR 2",
  "Demande de solde",
  "Dossier clôturé",
];
